import { ReactElement } from 'react';

import { ChakraText } from '@equip.health/ui';

import PatientTableCellToolTip from '~/components/common/PatientTableCellToolTip';

interface CounterProps {
  hideTooltip?: boolean;
  id: string;
  tooltipLabel: ReactElement;
  value: string;
}

const Counter = ({
  hideTooltip = false,
  id,
  tooltipLabel,
  value,
}: CounterProps) => (
  <PatientTableCellToolTip
    content={tooltipLabel}
    hidden={hideTooltip}
    id={`${id}__counter__tooltip`}
  >
    <ChakraText
      _hover={{ cursor: 'pointer' }}
      backgroundColor="neutral.line"
      borderRadius="100px"
      color="neutral.secondary"
      fontSize="10px"
      height="18px"
      id={`${id}__counter__label`}
      lineHeight="14px"
      padding="2px 6px 1px"
      width="25px"
    >
      {value}
    </ChakraText>
  </PatientTableCellToolTip>
);

export default Counter;
